import { z } from 'zod';
import { SecretReference } from 'libs/end-to-end/src/types/secrets/secret-reference';
import { BaseIntegration } from 'libs/end-to-end/src/types/databases/integrations/base-integration';

export const ShareFileIntegration = BaseIntegration.extend({
  integrationType: z.literal('ShareFile'),
  oauthUrlSecretReference: SecretReference.optional(),
  apiBaseUrlSecretReference: SecretReference.optional(),
  clientIdSecretReference: SecretReference.optional(),
  clientSecretSecretReference: SecretReference.optional(),
  usernameSecretReference: SecretReference.optional(),
  passwordSecretReference: SecretReference.optional(),
  folderIdSecretReference: SecretReference.optional(),
  fileNameSecretReference: SecretReference.optional(),
});

export type ShareFileIntegration = z.infer<typeof ShareFileIntegration>;
